import { render, staticRenderFns } from "./HeaderUser.vue?vue&type=template&id=642be57f&scoped=true"
import script from "./HeaderUser.vue?vue&type=script&lang=js"
export * from "./HeaderUser.vue?vue&type=script&lang=js"
import style0 from "./HeaderUser.vue?vue&type=style&index=0&id=642be57f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642be57f",
  null
  
)

export default component.exports